import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MassiveChangeStatusComponent } from './massive-change-status.component';
import { BtnStatusModule } from '../../../A2-utils/btn-status/btn-status.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    BtnStatusModule,
    FormsModule
  ],
  declarations: [MassiveChangeStatusComponent],
  exports: [MassiveChangeStatusComponent]
})
export class MassiveChangeStatusModule { }



// WEBPACK FOOTER //
// ./src/app/pages/dispatch/components/massive-change-status/massive-change-status.module.ts